/**
 * The old Governance → Integrations address. Integrations are Apps now
 * (`/$org/apps`); this redirect keeps bookmarks, inbox notifications and
 * server links working.
 *
 * @module routes/$org.compliance.integrations
 */
import { createFileRoute } from "@tanstack/react-router";

import { redirectLegacyIntegrations } from "../components/apps/legacyIntegrationsRoute";

export const Route = createFileRoute("/$org/compliance/integrations")({
  beforeLoad: ({ params, location }) => redirectLegacyIntegrations(location.pathname, params.org),
});
